import { render, staticRenderFns } from "./EditUiComponentLoader.vue?vue&type=template&id=2f8b0dc0"
import script from "./EditUiComponentLoader.vue?vue&type=script&lang=ts"
export * from "./EditUiComponentLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports